import { SubscriptionTier } from "@prisma/client";
import type Stripe from "stripe";

export const usagePricingConstants = {
  meterEventName: "api_frames_usage",
  productName: "API Frames Usage",
  lookupKeys: {
    starter: "api_pricing_starter_20250310",
    creator: "api_pricing_creator_20250209",
    pro: "api_pricing_pro_20250209",
  },
};

type TierWithUsagePricing = "starter" | Exclude<SubscriptionTier, "free">;

type TierData = Required<Pick<Stripe.PriceCreateParams.Tier, "unit_amount_decimal" | "up_to">>;
export const usagePricingByTier: Record<TierWithUsagePricing, [TierData, ...TierData[]]> = {
  starter: [
    {
      up_to: 100_000,
      unit_amount_decimal: "0.0900",
    },
    {
      up_to: 1_000_000,
      unit_amount_decimal: "0.0810",
    },
    {
      up_to: 5_000_000,
      unit_amount_decimal: "0.0720",
    },
    {
      up_to: 10_000_000,
      unit_amount_decimal: "0.0630",
    },
    {
      up_to: 50_000_000,
      unit_amount_decimal: "0.0540",
    },
    {
      up_to: "inf",
      unit_amount_decimal: "0.0450",
    },
  ],
  creator: [
    {
      up_to: 100_000,
      unit_amount_decimal: "0.1200",
    },
    {
      up_to: 1_000_000,
      unit_amount_decimal: "0.1080",
    },
    {
      up_to: 5_000_000,
      unit_amount_decimal: "0.0960",
    },
    {
      up_to: 10_000_000,
      unit_amount_decimal: "0.0840",
    },
    {
      up_to: 50_000_000,
      unit_amount_decimal: "0.0720",
    },
    {
      up_to: "inf",
      unit_amount_decimal: "0.0600",
    },
  ],
  pro: [
    {
      up_to: 100_000,
      unit_amount_decimal: "0.1950",
    },
    {
      up_to: 1_000_000,
      unit_amount_decimal: "0.1755",
    },
    {
      up_to: 5_000_000,
      unit_amount_decimal: "0.1560",
    },
    {
      up_to: 10_000_000,
      unit_amount_decimal: "0.1365",
    },
    {
      up_to: 50_000_000,
      unit_amount_decimal: "0.1170",
    },
    {
      up_to: "inf",
      unit_amount_decimal: "0.0975",
    },
  ],
  business: [
    {
      up_to: 100_000,
      unit_amount_decimal: "0.2500",
    },
    {
      up_to: 1_000_000,
      unit_amount_decimal: "0.2250",
    },
    {
      up_to: 5_000_000,
      unit_amount_decimal: "0.2000",
    },
    {
      up_to: 10_000_000,
      unit_amount_decimal: "0.1750",
    },
    {
      up_to: 50_000_000,
      unit_amount_decimal: "0.1500",
    },
    {
      up_to: "inf",
      unit_amount_decimal: "0.1250",
    },
  ],
};
